import { CheckoutState } from '../../state';
import {
    getIsOrganizationExcludedFromPostCheckoutMandatoryQuestions,
    isNativeApp,
} from '../app';
import {
    getIsNosSourceOfTruth,
    getShouldAcceptOffline,
    isSalesClient,
} from '../event';
import {
    hasRequiredCannedQuestions,
    hasRequiredCustomQuestions,
} from './pureSelectors';

export const getArePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet =
    (state: CheckoutState) =>
        !getIsOrganizationExcludedFromPostCheckoutMandatoryQuestions(state) &&
        !isNativeApp(state) &&
        hasRequiredCannedQuestions(state) &&
        !hasRequiredCustomQuestions(state) &&
        getIsNosSourceOfTruth(state) &&
        !isSalesClient(state) &&
        !getShouldAcceptOffline(state);
